import Header from "../components/Header";
import {ChatKit} from "@openai/chatkit-react";
import {useAIChatKit} from "../hooks/useAIChatKit";

export const AIAgent = () => {
    const {control} = useAIChatKit()

    return (
        <div className="dark">
            <Header/>
            <section className="relative w-full overflow-hidden h-[80vh] px-10 rounded-lg">
                <ChatKit
                    control={control}
                    className="h-full w-full rounded-lg"
                />
            </section>
        </div>)
}